var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-header navbar", attrs: { id: "app-header" } },
    [
      _c("div", { staticClass: "header-left-side" }, [
        _c(
          "div",
          {
            staticClass: "header-left-image noPaddingLeft noPaddingRight",
            on: {
              click: function($event) {
                _vm.resetSelectedClient()
              }
            }
          },
          [_c("b-link", { staticClass: "navbar-brand" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "header-middle align-center noPaddingLeft noPaddingRight"
          },
          [
            _c("div", { staticClass: "main-container" }, [
              _c("div", { staticClass: "fixer-container" }, [
                _c(
                  "div",
                  { staticClass: "display-inline-div custom-multiselect" },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.getAllClient,
                        placeholder: "Choose Client",
                        label: "clientName",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "clientName",
                        "allow-empty": true,
                        "show-labels": false,
                        disabled: _vm.isClientRole
                      },
                      on: { select: _vm.dropdownItemClick },
                      model: {
                        value: _vm.dropdownTitle,
                        callback: function($$v) {
                          _vm.dropdownTitle = $$v
                        },
                        expression: "dropdownTitle"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "display-inline-div float-right header-icon",
                  on: {
                    click: function($event) {
                      _vm.exportToExcelClick()
                    }
                  }
                },
                [
                  _c("Icon", {
                    staticClass: "header-sub-icon",
                    attrs: { name: "file-excel-o" }
                  })
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-right-text noPaddingRight noPaddingLeft" },
        [
          _c(
            "div",
            {
              staticClass: "header-icon",
              on: {
                click: function($event) {
                  _vm.openFaqModal()
                }
              }
            },
            [
              _c("Icon", {
                staticClass: "header-sub-icon",
                attrs: { name: "question-circle-o" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nameDisplay",
              on: {
                click: function($event) {
                  _vm.isShowUserAction = true
                },
                mouseleave: function($event) {
                  _vm.isShowUserAction = false
                }
              }
            },
            [
              _c("div", { staticClass: "header-right-name" }, [
                _vm._v(_vm._s(_vm.userName))
              ]),
              _vm._v(" "),
              !_vm.isClientRole
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.userRole))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isClientRole
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.clientNameForClient))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-action-icon" },
                [_c("Icon", { attrs: { name: "sort-down" } })],
                1
              ),
              _vm._v(" "),
              _vm.isShowUserAction
                ? _c("div", { staticClass: "user-action-panel" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.logout()
                            }
                          }
                        },
                        [_vm._v("Logout")]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.resetPassword()
                            }
                          }
                        },
                        [_vm._v("Change Password")]
                      ),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("Email notification: "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isReceiveEmail,
                              expression: "isReceiveEmail"
                            }
                          ],
                          attrs: { type: "checkbox", id: "switch" },
                          domProps: {
                            checked: Array.isArray(_vm.isReceiveEmail)
                              ? _vm._i(_vm.isReceiveEmail, null) > -1
                              : _vm.isReceiveEmail
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isReceiveEmail,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isReceiveEmail = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isReceiveEmail = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isReceiveEmail = $$c
                              }
                            }
                          }
                        }),
                        _c("label", { attrs: { for: "switch" } }, [
                          _vm._v("Toggle")
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10970f03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10970f03","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/header/Header.vue
// module id = 1827
// module chunks = 1